import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import FundFinderRoot, { type Props } from "./FundFinder";

const queryClient = new QueryClient();

export default function FundFinderWidget(props: Props) {
    return (
        <QueryClientProvider client={queryClient}>
            <FundFinderRoot {...props} />
        </QueryClientProvider>
    );
}
